import { useQuery } from "@tanstack/react-query";
import api from "services/api";
import { User, UsersResponse } from "types/user.types";

export type { User };

/**
 * Hook to fetch the list of users with pagination
 */
export const useUsers = (
  page = 1,
  limit = 10,
  sortField?: string,
  sortOrder?: string,
  search?: string
) => {
  return useQuery({
    queryKey: ["users", page, limit, sortField, sortOrder, search],
    refetchOnWindowFocus: true,
    staleTime: 0,
    queryFn: async (): Promise<UsersResponse> => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (sortField) {
        params.append("sortField", sortField);
      }

      if (sortOrder) {
        params.append("sortOrder", sortOrder);
      }

      if (search && search.trim() !== "") {
        params.append("search", search);
      }

      try {
        const response = await api.get<UsersResponse>(
          `admin/users?${params.toString()}`
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    },
  });
};
